import { Controller } from "@hotwired/stimulus"

// Garde-fou anti-doublon : pendant la saisie d'un libellé, les champs proches (système compris).
export default class extends Controller {
  static targets = ["input", "frame"]
  static values = { url: String }

  disconnect() { clearTimeout(this.timer) }

  refresh() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("label", this.inputTarget.value.trim())
      this.frameTarget.src = url.toString()
    }, 250)
  }
}
